// Sales Velocity shared helpers: API, formatting (year shown when not this year), status colours.
import axios from "axios";

const API = process.env.REACT_APP_BACKEND_URL + "/api/crm/velocity";
export const vApi = {
  get: (path, params) => axios.get(`${API}${path}`, { params, withCredentials: true }).then((r) => r.data),
  post: (path) => axios.post(`${API}${path}`, {}, { withCredentials: true }).then((r) => r.data),
};

const isLight = () => document.documentElement.getAttribute("data-talmia-theme") === "light";
const themed = (dark, light) => new Proxy({}, { get: (_, k) => (isLight() ? light : dark)[k] });
// Neon on navy, deep inks on white — read at render time so the universal theme switch applies.
export const STATUS_COL = themed({ Active: "#3fd28a", Cooling: "#f3b13c", Lapsed: "#f06b7a", Dormant: "#6f7c93" }, { Active: "#15803D", Cooling: "#B45309", Lapsed: "#B91C1C", Dormant: "#475569" });
export const BAND_COL = themed({ Top: "#f3c85a", Mid: "#c3cad6", Low: "#d08a5a" }, { Top: "#8A6516", Mid: "#475569", Low: "#9A3412" });

export const gbp = (n, dp = 0) => `£${Number(n || 0).toLocaleString("en-GB", { minimumFractionDigits: dp, maximumFractionDigits: dp })}`;
export const vDate = (v) => {
  if (!v) return "—";
  const d = new Date(v);
  if (isNaN(d)) return "—";
  const y = d.getFullYear() !== new Date().getFullYear();
  return d.toLocaleDateString("en-GB", { day: "numeric", month: "short", ...(y ? { year: "numeric" } : {}) });
};
export const monthLabel = (k) => { const [y, m] = k.split("-").map(Number); const d = new Date(y, m - 1, 1); return d.toLocaleDateString("en-GB", { month: "short", ...(y !== new Date().getFullYear() ? { year: "2-digit" } : {}) }); };

export const StatusChip = ({ s }) => s ? (
  <span className="inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-[10.5px] font-mono border" style={{ color: STATUS_COL[s], borderColor: `${STATUS_COL[s]}55`, background: `${STATUS_COL[s]}14` }}>
    <span className="w-1.5 h-1.5 rounded-full" style={{ background: STATUS_COL[s] }} />{s}
  </span>) : null;

export const BandChip = ({ b }) => b ? <span className="text-[10.5px] font-mono px-1.5 py-0.5 rounded border" style={{ color: BAND_COL[b], borderColor: `${BAND_COL[b]}55` }}>{b}</span> : <span className="text-slate-600">—</span>;

export const Chip = ({ on, onClick, children, testid }) => (
  <button type="button" onClick={onClick} data-testid={testid}
    className={`px-2.5 py-1 rounded-full border text-[11.5px] transition-colors ${on ? "border-teal-400/60 bg-teal-500/15 text-teal-100" : "border-white/10 bg-white/[0.02] text-slate-300 hover:border-white/25"}`}>{children}</button>
);
